import { render, staticRenderFns } from "./RadioSetting.vue?vue&type=template&id=22498992&scoped=true"
import script from "./RadioSetting.vue?vue&type=script&lang=js"
export * from "./RadioSetting.vue?vue&type=script&lang=js"
import style0 from "./RadioSetting.vue?vue&type=style&index=0&id=22498992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22498992",
  null
  
)

export default component.exports